export function ExperienceBadge() {
  return (
    <div className="flex items-center justify-center gap-1.5">
      <span className="text-muted-foreground text-xs">Uma experiência</span>
      <img src="/images/logo-text.png" alt="eumimo" className="h-5" />
    </div>
  );
}
